import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const LoginContent = ({ setActive }) => {
    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem("convertMobile");

        if (!saved) return;

        try {
            const obj = JSON.parse(saved);

            // شرایط لازم:
            // ۱. login === false
            // ۲. mobile وجود داشته باشد و خالی نباشد
            if (obj?.login === true && obj?.mobile) {

                // تبدیل اعداد فارسی به انگلیسی (ضد‌خطا)
                const convertFaToEn = (str) => {
                    const fa = "۰۱۲۳۴۵۶۷۸۹";
                    const en = "0123456789";
                    return str.replace(/[۰-۹]/g, (d) => en[fa.indexOf(d)]);
                };

                const phone = convertFaToEn(obj.mobile.toString()).replace(/[^0-9]/g, "");

                setMobile(phone);
            }

        } catch (err) {
            // اگر JSON خراب بود کاری نکنیم
        }
    }, []);

    // جلوگیری از توست‌های پشت سر هم
    const showToast = (type, message) => {
        if (toast.isActive("global-toast")) return;
        type(message, { toastId: "global-toast" });
    };

    // تبدیل اعداد فارسی به انگلیسی
    const toEnglishDigits = (str) => {
        return str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    };

    // هندل ورودی
    const handleInput = (value) => {
        let english = toEnglishDigits(value);

        // جلوگیری از ورود حروف
        if (!/^[0-9]*$/.test(english)) {
            showToast(toast.error, "لطفا شماره تماس خود را انگلیسی وارد کنید");
            return;
        }

        // فقط ثبت مقدار صحیح
        setMobile(english);
    };

    // ارسال OTP
    const handleSendOtp = async () => {

        // جلوگیری از ارسال هم‌زمان
        if (loading) return;

        // 1) چک طول شماره
        if (mobile.length !== 11) {
            showToast(toast.error, "لطفا شماره تماس صحیح وارد کنید");
            return;
        }

        // 2) چک عددی بودن
        if (!/^[0-9]{11}$/.test(mobile)) {
            showToast(toast.error, "لطفا شماره تماس وارد کنید نه حروف");
            return;
        }

        // 3) بررسی OTP ذخیره‌شده قبلی
        const otpData = JSON.parse(localStorage.getItem("otp"));

        if (otpData?.otpSended === true) {
            
            const lastSend = new Date(otpData.otpSendTime).getTime();
            const now = Date.now();
            const diff = now - lastSend; // اختلاف زمانی به میلی‌ثانیه

            const ONE_MINUTE = 60 * 1000;

            // اگر کمتر از یک دقیقه گذشته:
            if (diff < ONE_MINUTE && otpData?.phone === mobile) {
                // مستقیم بفرست صفحه وارد کردن OTP
                navigate("/auth/otp");
                return;
            }
            // اگر بیشتر از یک دقیقه گذشته → اجازه بده درخواست جدید بره
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/auth/login",
                { phone: mobile }
            );

            showToast(toast.success, res.data?.message || "کد اعتبارسنجی ارسال شد");

            // ذخیره مجدد otp جدید
            localStorage.setItem('otp', JSON.stringify({
                otpSended: true,
                otpSendTime: new Date().toISOString(),
                login: true,
                phone: mobile
            }));

            navigate("/auth/otp");

        } catch (err) {
            
            const msg =
                err?.response?.data?.message ||
                "مشکلی در ارسال کد اعتبارسنجی وجود دارد";

            showToast(toast.error, msg);

            // اگر پیام خطا دقیقا همین بود → تب را ببریم روی ثبت نام
            if (msg === "کاربری با این شماره وجود ندارد ثبت نام کنید") {
                setActive("register");
                localStorage.setItem('convertMobile', JSON.stringify({
                    mobile,
                    login: false,
                }))
            }

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mt-8 space-y-8">

            {/* input */}
            <div className="space-y-1">

                <label className="text-[15px] text-slate-600">
                    برای ورود لطفا شماره موبایل خود را وارد کنید
                </label>

                <div className="relative">

                    <input
                        type="tel"
                        value={mobile}
                        onChange={(e)=>handleInput(e.target.value)}
                        placeholder="مثلا 09123456789"
                        maxLength={11}
                        className="
                        w-full
                        rounded-lg
                        border
                        border-slate-300
                        bg-slate-200
                        px-4
                        py-3
                        text-sm
                        outline-none
                        placeholder:pr-8
                        placeholder:text-right
                        transition
                        focus:border-third
                        "
                    />

                    {/* icon */}
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                        <ReactSVG
                            src={`${process.env.PUBLIC_URL}/assets/images/icons/mobile.svg`}
                            className="w-6 h-6 -scale-x-100"
                        />
                    </div>

                </div>

            </div>


            {/* button */}
            <button
                onClick={handleSendOtp}
                disabled={loading}
                className={`
                    w-full
                    block
                    bg-primary
                    text-white
                    text-sm
                    font-medium
                    py-3.5
                    rounded-lg
                    transition
                    hover:opacity-90
                    active:scale-[0.98]
                    shadow-sm
                    ${loading ? "opacity-70 cursor-not-allowed" : ""}
                `}
            >
                {loading ? (
                    <span className="flex items-center justify-center gap-2">
                        <Loader2 className="w-4 h-4 animate-spin" />
                        درحال ارسال کد
                    </span>
                ) : (
                    "ورود و رزرو وقت"
                )}
            </button>

        </div>
    )
}

export default LoginContent;